import React, { useMemo } from 'react';
import { FormMode } from '../../../../../screens/Admin/constants/constants';

const FIELD_NAME = '$set-as-current';

const withSetAsCurrentField = (Component) => {
  return ({ mode, items, pages, name, form, onSubmit, ...props }) => {
    const formItems = useMemo(() => {
      const setAsCurrentField = {
        type: 'toggle',
        name: FIELD_NAME,
        title: `Set new ${name} as current.`,
      };

      if (pages) {
        if (mode === FormMode.CREATE) {
          return pages.map((page, index) => {
            if (index === pages.length - 1) {
              return {
                ...page,
                items: [
                  ...page.items,
                  setAsCurrentField,
                ],
              };
            }

            return page;
          });
        }

        return pages;
      }

      if (mode === FormMode.CREATE) {
        return [...items, setAsCurrentField];
      }

      return items;
    }, [items, pages, mode]);

    const handleSubmit = async (values) => {
      const data = { ...values };
      delete data[FIELD_NAME];

      try {
        const entityId = await onSubmit(data);

        if (values[FIELD_NAME]) {
          form.setValues({ ...form.values, [name]: entityId });
        }
      } catch (e) {
        throw new Error(e.message);
      }
    };

    return (
      <Component
        {...props}
        mode={mode}
        items={formItems}
        name={name}
        onSubmit={handleSubmit}
      />
    );
  };
};

export default withSetAsCurrentField;
